module.exports = __webpack_public_path__ + "static/media/play.ff636c26.svg";